export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''

// AI Chatbot Configuration
export const CHATBOT_API_URL = import.meta.env.VITE_CHATBOT_API_URL || 'https://www.siluxchat.com'
export const CHATBOT_TENANT = import.meta.env.VITE_CHATBOT_TENANT || 'siluxmobile'
export const CHATBOT_API_KEY = import.meta.env.VITE_CHATBOT_API_KEY || 'K3Z6yik3JGqh9gzRRqGyO8Upz2opvmIUyGHJtmRAdgk'

// WhatsApp Configuration
export const WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER || ''

export const config = {
  apiBaseUrl: API_BASE_URL,
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  chatbot: {
    apiUrl: CHATBOT_API_URL,
    tenant: CHATBOT_TENANT,
    apiKey: CHATBOT_API_KEY,
    chatEndpoint: `${CHATBOT_API_URL}/api/chat/${CHATBOT_TENANT}`,
    whatsappEndpoint: `${CHATBOT_API_URL}/api/whatsapp/incoming`,
  },
  whatsappNumber: WHATSAPP_NUMBER,
}
